<template>
  <div class="about mt-12">
    <!-- 予約システム -->
    <v-layout column wrap align-center style="background-color:#f0f0f0">
        <v-flex xs12 sm10 mt-12>
            <v-alert
                border="bottom"
                colored-border="blue"
                color="light-blue"
                prominent
                min-width="100%"
                class="display-1">
                予約システム
            </v-alert>
        </v-flex>
    </v-layout>
    <iframe type="text/html" frameborder="0" width="100%" height="1230px" src="//airrsv.net/terarpa/calendar/embed/" ></iframe>
    <Footer/>
  </div>
</template>



<script>
import Footer from "@/components/Footer";
export default {
  name: "App",
  data() {
    return {};
  },
  components: {
    Footer
  }
};
</script>
